import _ from 'lodash'

/**
 * Remove duplicatas preservando o tipo original
 * @example unique(['a', 'b', 'a']) => ['a', 'b']
 */
export function unique<T>(arr: T[]): T[] {
  return [...new Set(arr)]
}

/**
 * Remove duplicatas com base na chave `id` (ideal para objetos com ID)
 * @example uniqueById([{ id: 1 }, { id: 2 }, { id: 1 }]) => [{ id: 1 }, { id: 2 }]
 */
export function uniqueById<T extends { id: string | number }>(arr: T[]): T[] {
  return Object.values(_.keyBy(arr, 'id'))
}

/**
 * Compara se dois arrays têm os mesmos elementos (ignorando ordem, duplicatas e valores vazios)
 * @param array1 Primeiro array a ser comparado
 * @param array2 Segundo array a ser comparado
 * @returns true se os arrays têm os mesmos elementos, false caso contrário
 * @example hasSameEl(['a', 'b', 'a'], ['b', 'a']) => true
 */
export const hasSameEl = <T>(array1: T[], array2: T[]): boolean => {
  // Remove duplicates
  let newArray1 = [...new Set(array1)]
  let newArray2 = [...new Set(array2)]

  // Remove null and empty values
  newArray1 = newArray1.filter(el => el !== null && el !== '')
  newArray2 = newArray2.filter(el => el !== null && el !== '')

  // Sort arrays
  newArray1 = newArray1.sort()
  newArray2 = newArray2.sort()

  if (newArray1.length !== newArray2.length) return false
  return newArray1.every((el, idx) => el === newArray2[idx])
}

// Alias para compatibilidade com código existente
export { hasSameEl as arrayHasSameEl }
